import { useEffect, useState } from 'react';

import { createCache as createCacheExchange, createClient } from '../client';
import { logger } from '../logger';
import type { OfflineStorage } from '../storage';
import { offlineStorage } from '../storage';
import type { ErrorHandlerReference } from './UrqlContext';

// ────────────────────────────────────────────────────────────────────────────────

type ClientState = Awaited<ReturnType<typeof makeClient>> | null;

export const useUrqlClient = (errorHandlerReference: ErrorHandlerReference) => {
  const [client, setClient] = useState<ClientState>(null);

  useEffect(() => {
    (async () => {
      setClient(
        await makeClient({ storage: offlineStorage, errorHandlerReference }),
      );
    })();
  }, [errorHandlerReference]);

  return client;
};

// ──── Utils ────────────────────────────────────────────────────────────

const makeClient = async (options: MakeClientOptions) => {
  const cacheExchange = createCacheExchange(options.storage);

  logger.debug('Created urql client');

  return createClient(cacheExchange, options.errorHandlerReference);
};

// ─── Types ─────────────────────────────────────────────────────────────

type MakeClientOptions = {
  readonly storage: OfflineStorage;
  readonly errorHandlerReference: ErrorHandlerReference;
};
